
import { LoginForm, AuthLayout } from "modules/Authentication/components";
import LegalitiesPolicy from "modules/Authentication/components/LegalitiesPolicy/LegalitiesPolicy";

type Props = {};

const LegalitiesPolicyContainer = (props: Props) => {


  return (
    <AuthLayout>

      <LegalitiesPolicy

      />

    </AuthLayout>
  );
};

export default LegalitiesPolicyContainer;
